<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="10" lg="8">
        <b-card v-show="showList">
          <div slot="header">
            Jenis Kiriman Koran
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive
            hover
            small
            style="font-size:smaller;"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(seqno)="data">{{ data.index +1}}</template>
            <template v-slot:cell(gratis)="data">
              <span v-if="(data.item.gratis==1)">GRATIS</span>
              <span v-else>BAYAR</span>
            </template>
            <template v-slot:cell(harga)="data">{{data.item.harga|numFormat}}</template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click.stop="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click.stop="deleteConfirm(data.item)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to
                <span
                  v-if="((tblData.page * tblData.limit)>tblData.total)"
                >{{tblData.total}}</span>
                <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Jenis Kiriman - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Kiriman</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.kiriman_name"
              :state="!$v.frmdata.kiriman_name.$error"
              placeholder="Nama kiriman"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Pembayaran</label>
              </b-input-group-prepend>
              <b-form-radio-group  v-model="frmdata.gratis" >
                <b-form-radio value="1">GRATIS</b-form-radio>
                <b-form-radio value="0">BAYAR</b-form-radio>
              </b-form-radio-group>
          </b-input-group>
          <b-input-group class="mr-4">
            <b-input-group-prepend >
              <label>Harga Eceran</label>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
            </b-input-group-prepend>
            <my-number 
              class="form-control text-right"
              separator=","
              v-model="frmdata.harga"
              :precision="2"
            ></my-number>
          </b-input-group>

          <b-input-group>
              <b-input-group-prepend>
                <label>Sales/Revenue Acc.</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="frmdata.salesaccInfo"
                :state="!$v.frmdata.salesacc.$error"
                placeholder="Sales/Revenue GL Account"
              ></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="showLkuCoa('salesacc')" >
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Urutan Display</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.seqno"
              :state="!$v.frmdata.seqno.$error"
              type="number"
              placeholder="Urutan display"
              min="0"
            ></b-form-input>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        

  </div>
</template>


<script>
import toastr from "mini-toastr";
import { v4 as uuid } from 'uuid';
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import lkuCoa from "../lookup/lkuCoa";

toastr.init();

export default {
  components: {myNumber,lkuCoa},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      kiriman_name: { required },
      salesacc: {required : (function() {
          if ((this.frmdata.gratis || 0) == 1) {
              return true;
          } else if (!(this.frmdata.salesacc)){
              return false;
          } else return true;
      })},
      seqno: { required }
    }
  },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList: true,
      showForm: false,
      lkuCoaShow:false,
      lkuCoaCaller:'salesacc',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      uanguser: this.$store.state.user.matauang,
      frmdata: { kiriman_name: "", salesacc:'', gratis:0, harga:0 },
      tblData: {
        tablename: "koranjeniskiriman",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "seqno",
        sortDesc: false
      }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "kiriman_name",
          label: "Nama Kiriman",
          sortable: true
        },
        {
          key: "gratis",
          label: "Bayar",
          sortable: true
        },
        {
          key: "harga",
          label: "Harga",
          sortable: true
        },
        {
          key: "salesaccInfo",
          label: "Revenue Account",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center"
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  created: function() {
    this.$watch('frmdata.gratis', function(newVal) {
        setTimeout(() => {
          if (this.frmdata.gratis==1) {
            this.frmdata.harga=0;
          }
        }, 100);
    });   

  },
  methods: {
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.frmdata[`${this.lkuCoaCaller}Name`] = _selected.namaacc.trim();
        this.frmdata[this.lkuCoaCaller] = _selected.kodeacc;
        this.lkuCoaShow=false;
    },

    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.kiriman_code;
      this.frmdata.salesaccInfo = data.salesacc;
      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.gratis==1) {
            this.frmdata.harga=0;
          }
          if (this.frmdata.idlama) {
            await crud.update({
              tablename: "koranjeniskiriman",
              key: this.frmdata.idlama,
              data: {
                kiriman_code: this.frmdata.kiriman_code,
                kiriman_name: this.frmdata.kiriman_name,
                harga: this.frmdata.harga,
                salesacc: this.frmdata.salesacc,
                salesaccInfo: this.frmdata.salesaccInfo,
                gratis: this.frmdata.gratis || '0',
                seqno: this.frmdata.seqno
              }
            });
          } else {
            await crud.insert({
              tablename: "koranjeniskiriman",
              data: {
                kiriman_code: uuid(),
                kiriman_name: this.frmdata.kiriman_name,
                harga: this.frmdata.harga,
                salesacc: this.frmdata.salesacc,
                salesaccInfo: this.frmdata.salesaccInfo,
                gratis: this.frmdata.gratis || '0',
                seqno: this.frmdata.seqno
              }
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({
        tablename: "koranjeniskiriman",
        key: this.model.kiriman_code
      });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
